import React from "react";
import GuideSequence from "../components/GuideSequence";
import GuidePopover from "../components/NativeGuidePopover";
import type { GuideProps } from "../NativeGuideTypes";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";
import { appstr } from "@coreapp/utils/appstr";

const FeatureTourGuide: React.FC<GuideProps> = props => {
  const {
    canAccessViewSwitcher,
    canAccessInteractiveFilters,
    canAccessInteractiveHighlights,
    canExport
  } = usePermissionCheck();

  return (
    <GuideSequence {...props}>
      {canAccessViewSwitcher && (
        <GuidePopover anchor="[data-testid='mtb-views-menu-trigger']" placement="bottom-end">
          {appstr(
            "Click on the view switcher to change the information that is displayed on the chart. Your chart comes with three pre-installed views."
          )}
        </GuidePopover>
      )}
      <GuidePopover anchor="[data-testid='ctb-levels-menu']" placement="bottom-end">
        {appstr(
          "Use the levels control to increase or decrease the amount of organizational levels displayed on a single page."
        )}
      </GuidePopover>
      {(canAccessInteractiveFilters || canAccessInteractiveHighlights) && (
        <GuidePopover anchor="[data-testid='rsb-toggle-filters']" placement="left-start">
          {appstr(
            "Create filters to show specific records. For example, filter your chart to just see Full Time employees. Create highlights to illuminate specific records. For example, quickly highlight employees who work in New York."
          )}
        </GuidePopover>
      )}
      {canExport && (
        <GuidePopover anchor="[data-testid='header-export-menu']" placement="left-start">
          {appstr(
            "Instantly get presentation-ready org charts. Export your chart to PPT, PDF, SVG, and additional formats."
          )}
        </GuidePopover>
      )}
    </GuideSequence>
  );
};

export default FeatureTourGuide;
